import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const changeRequestList = createAsyncThunk("changeRequest/list", async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `approval_request`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
                unit_id: data?.unit_id,
                status: data?.status,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        });
        return res;
    } catch (error) {
        return error.response;
    }
});

export const setChangeRequestStatus = createAsyncThunk("changeRequest/setStatus", async ({ id, status }) => {
    try {
        const res = await axios({
            method: "PUT",
            url: getConfig.API_URL + `approval_request`,
            data: {
                request_id: id,
                status,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        });
        return res;
    } catch (error) {
        return error.response;
    }
});

const changeRequestSlice = createSlice({
    name: "changeRequest",
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(changeRequestList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate);
            } else {
                state.list = [];
            }
        });
    },
});

export default changeRequestSlice.reducer;